<template>
    <div class="card dashboard-card h-100">
        <div class="card-body">
            <span class="eyebrow">Leads overview</span>
            <h4 class="card-title">Leads health</h4>
            <p class="period-label">Period: {{ periodLabel }}</p>

            <div class="summary-grid">
                <div>
                    <small class="metric-label">Total leads</small>
                    <div class="metric-value">{{ stats.total }}</div>
                </div>
                <div>
                    <small class="metric-label">In sales</small>
                    <div class="metric-value text-success">{{ stats.inSales }}</div>
                </div>
                <div>
                    <small class="metric-label">Spam</small>
                    <div class="metric-value text-warning">{{ stats.spam }}</div>
                </div>
                <div>
                    <small class="metric-label">Trash</small>
                    <div class="metric-value text-danger">{{ stats.trash }}</div>
                </div>
            </div>

            <div class="mt-3">
                <small class="metric-label">Uncategorized source: {{ stats.uncategorized }}</small>
            </div>

            <div class="mini-chart" v-if="chartData.length > 1">
                <GChart
                    :settings="{ packages: ['corechart'] }"
                    type="PieChart"
                    :data="chartData"
                    :options="chartOptions"
                    :resizeDebounce="500"
                ></GChart>
            </div>
        </div>
    </div>
</template>
<script>
import { GChart } from "vue-google-charts";

export default {
    name: "SummaryLeadsStatusCard",
    components: {
        GChart,
    },
    props: {
        stats: {
            type: Object,
            required: true,
        },
        periodLabel: {
            type: String,
            default: "2020 - current",
        },
    },
    computed: {
        chartData() {
            return [
                ["Type", "Count"],
                ["Active", this.stats.active],
                ["In sales", this.stats.inSales],
                ["Spam", this.stats.spam],
                ["Trash", this.stats.trash],
            ];
        },
        chartOptions() {
            return {
                pieHole: 0.40,
                height: 220,
                backgroundColor: "transparent",
                chartArea: { left: 10, top: 10, width: "95%", height: 160 },
                legend: { position: "bottom", textStyle: { color: "#4c5968", fontSize: 16 } },
                tooltip: { textStyle: { color: "#28323c", fontSize: 14 } },

                colors: ["#3b82f6", "#16a34a", "#f59e0b", "#ef4444"],
            };
        },
    },
};
</script>
<style scoped>
.dashboard-card {
    border: 1px solid #dbe4ea;
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba(31, 60, 90, 0.08);
    min-height: 450px;
    margin-bottom: 20px;
}
.dashboard-card .card-body {
    background-color: #ffffff;
}

.eyebrow {
    display: block;
    color: #6f7d8a;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.card-title {
    margin: 4px 0 16px;
    color: #24313f;
    font-size: 24px;
    font-weight: 700;
}

.period-label {
    margin: -10px 0 16px;
    color: #6f7d8a;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
}

.metric-label {
    color: #788491;
    display: block;
    margin-bottom: 4px;
}

.metric-value {
    color: #24313f;
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
}

.mini-chart {
    margin-top: 8px;
}
</style>
